const module = {
  config: {
    name: 'transaction',
    icon: 'ri-input-cursor-move',
    desc: 'PMIS Infrastruktur II',
    layout: true,
    permission: 'view-project_forms'
  },
  routes: [
    { name: 'data-input', label: 'Data Transaksi', icon: null, path: '/data-input', component: () => import('./project-forms.vue') }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/input-data/_index.js